export const environment = {
    production: true,
    appName: 'Blumepress Pressroom',
    url: `https://api-dev.blumepress.com/`,
    email: `pressroom-dev`,
    main_url: `https://app-dev.blumepress.com/`,
    outreachEmail: 'outreach-dev',
    emailDomain: `@blumepress.com`,
    s3Url: 'https://pressroom-dev.s3.eu-west-1.amazonaws.com',
    livesiteUrl: `https://pressroom-dev.blumepress.com/`,
    outreachUrl: `https://outreach-dev.blumepress.com/`,
    googleClientId:
        '24810449064-ai75to876ide1n89rqjlfromasdu4dfd.apps.googleusercontent.com',
    formspreeEndpoint: 'https://formspree.io/f/xeqydaqv',
};
